function setTagalysConfiguration() {
  const tagalysConfig = window.__TAGALYS_CURRENCY_CONTEXT__

  if (!window.Tagalys || !tagalysConfig) return

  Tagalys.setConfiguration({
    api: {
      serverUrl: tagalysConfig.serverUrl || 'https://api-r3.tagalys.com',
    },
    locale: 'en-US',
    currency: {
      displayFormatter: '{{currencyLabel}}{{value}}',
      code: window.__TAGALYS_CURRENCY_CONTEXT__.isoCode,
      label: window.__TAGALYS_CURRENCY_CONTEXT__.symbol,
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function () {
      return true
    },
    track: true,
  })
}

function setPlatformConfigurationForTagalys() {
  const tagalysConfig = window.__TAGALYS_CURRENCY_CONTEXT__

  if (!window.Tagalys || !tagalysConfig) return

  Tagalys.setPlatformConfiguration({
    storefrontAPI: {
      myShopifyDomain: tagalysConfig.domain,
      accessToken: tagalysConfig.api,
    },
    metafields: {
      products: [
        {
          namespace: 'specs',
          key: 'case_diameter',
        },
        {
          namespace: 'specs',
          key: 'band_material',
        },
        {
          namespace: 'merchandise',
          key: 'variants',
        },
      ],
    },
    platform: 'Shopify',
    countryCode: Shopify.country,
    baseCountryCode: tagalysConfig.baseCountryCode || 'US',
    useStorefrontAPIForSecondaryMarkets: false,
    waitForStorefrontAPI: true,
  })
}

function onTagalysReady(callback) {
  if (window.Tagalys) {
    setTagalysConfiguration()
    setPlatformConfigurationForTagalys()
    callback()
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      setTagalysConfiguration()
      setPlatformConfigurationForTagalys()
      callback()
    })
  }
}
